import {
  InputRequirement,
  InputRequirementSchema,
} from "@intelligems/ig-types/schemas/ai/nodes/input-requirement";
import { ToolResultOutputSchema } from "@intelligems/ig-types/schemas/ai/nodes/tool-execution-result";

export const readRequestUserInputOutput = (
  output: unknown
): InputRequirement | undefined => {
  // Native MCP results wrap the same application payload in text content.
  if (typeof output === "string") {
    try {
      output = JSON.parse(output);
    } catch {
      return undefined;
    }
  }
  const content = Array.isArray(output)
    ? output
    : output && typeof output === "object" && "content" in output
      ? output.content
      : undefined;
  if (Array.isArray(content)) {
    for (const part of content) {
      if (
        part &&
        typeof part === "object" &&
        part.type === "text" &&
        typeof part.text === "string"
      ) {
        try {
          const parsed = ToolResultOutputSchema.safeParse(
            JSON.parse(part.text)
          );
          if (parsed.success) {
            output = parsed.data;
            break;
          }
        } catch {
          /* Other text content is not an input requirement. */
        }
      }
    }
  }
  const parsedOutput = ToolResultOutputSchema.safeParse(output);
  if (!parsedOutput.success || parsedOutput.data.type !== "json") {
    return undefined;
  }

  const parsedRequirement = InputRequirementSchema.safeParse(
    parsedOutput.data.value.results
  );
  if (
    !parsedRequirement.success ||
    typeof parsedRequirement.data.prompt !== "string"
  ) {
    return undefined;
  }

  return parsedRequirement.data;
};

export const isRequestUserInputTool = (name: string): boolean =>
  name === "request-user-input" || name.endsWith("__request-user-input");
